<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height" style="background-color: #E7F2F9;">
        <v-row justify="center" align="center" class="fill-height">
          <v-col cols="12" sm="6" md="6" lg="4" xl="3">
            <v-card class="signup-card" elevation="8" rounded="lg">
              <v-card-title class="signup-header text-center pa-6 text-black">
                <div class="w-100 d-flex flex-column align-center">
                  <v-avatar size="200" class="mb-3">
                    <v-img :src="logo" alt="500px"></v-img>
                  </v-avatar>
                  <v-card-subtitle class="text-center text-h4 font-weight-bold mb-6" style="color: var(--color-primary);">
                    Cadastro Sicon I.A
                  </v-card-subtitle>
                  <p class="text-subtitle-1">Preencha os campos abaixo para se cadastrar</p>
                </div>
              </v-card-title>

              <v-card-text class="pa-6">
                <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
                  <v-text-field
                    v-model="form.nome"
                    label="Nome completo"
                    prepend-inner-icon="fas fa-user mr-2"
                    variant="outlined"
                    class="mb-4"
                    :rules="nomeRules"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="form.email"
                    label="E-mail"
                    prepend-inner-icon="fas fa-envelope mr-2"
                    variant="outlined"
                    class="mb-4"
                    type="email"
                    placeholder="seu@email.com"
                    :rules="emailRules"
                    required
                  ></v-text-field>

                  <v-select
                    v-model="form.departamento"
                    :items="departamentos"
                    item-value="id"
                    item-title="name"
                    label="Departamento"
                    prepend-inner-icon="fas fa-building"
                    variant="outlined"
                    class="mb-4"
                    :rules="departamentoRules"
                    required
                  ></v-select>

                  <v-text-field
                    v-model="form.senha"
                    :type="showPassword ? 'text' : 'password'"
                    label="Senha"
                    prepend-inner-icon="fas fa-lock mr-2"
                    :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append-inner="togglePassword"
                    variant="outlined"
                    class="mb-5"
                    :rules="senhaRules"
                    required
                  />

                  <p class="text-caption text-medium-emphasis mb-4">
                    A senha deve conter pelo menos 8 caracteres
                  </p>

                  <v-btn
                    type="submit"
                    size="large"
                    block
                    class="signup-btn mb-4"
                    :disabled="!valid"
                    :loading="loading"
                  >
                    <p class="text-white">Cadastrar</p>
                  </v-btn>

                  <div class="text-center">
                    <span class="text-body-2 text-medium-emphasis">
                      Já tem uma conta? 
                      <a href="/" class="text-primary text-decoration-none font-weight-medium">
                        Faça login
                      </a>
                    </span>
                  </div>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          timeout="3000"
          location="top"
        >
          {{ snackbarText }}
          <template #actions>
            <v-btn text @click="snackbar = false">OK</v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios'

const API_BASE = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '')

export default {
  name: 'SignupForm',

  data() {
    return {
      valid: false,
      loading: false,
      showPassword: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      form: {
        nome: '',
        email: '',
        senha: '',
        departamento: null,
      },
      departamentos: [
        { id: 1, name: 'Financeiro' }, 
        { id: 2, name: 'Manutenção' }, 
        { id: 3, name: 'Cobranças' }, 
        { id: 4, name: 'Atendimento Geral' }, 
        { id: 5, name: 'RH' }, 
        { id: 6, name: 'Administrativo' }
      ],
      logo: require('@/assets/sicon.png'),
      nomeRules: [
        v => !!v || 'Nome é obrigatório',
        v => v.length >= 2 || 'Nome deve ter pelo menos 2 caracteres'
      ],
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+\..+/.test(v) || 'E-mail deve ser válido'
      ],
      senhaRules: [
        v => !!v || 'Senha é obrigatória',
        v => v.length >= 8 || 'Senha deve ter pelo menos 8 caracteres'
      ],
      departamentoRules: [
        v => !!v || 'Departamento é obrigatório'
      ]
    }
  },

  methods: {
    async handleSubmit() {
      if (this.valid) {
        this.loading = true
        try {
          const { data } = await axios.post(`${API_BASE}/user`, {
            name: this.form.nome,
            email: this.form.email,
            password: this.form.senha,
            departmentId: this.form.departamento
          })

          localStorage.setItem('authToken', data.token)

          this.snackbarText = 'Cadastro realizado com sucesso!'
          this.snackbarColor = 'success'
          this.snackbar = true

          setTimeout(() => {
            this.$router.push({ name: 'CondoDashBoard' })
          }, 1500)

          this.$refs.form.reset()
        } catch (error) {
          console.error('Erro no cadastro:', error)

          this.snackbarText = 'Erro ao cadastrar. Tente novamente!'
          this.snackbarColor = 'error'
          this.snackbar = true
        } finally {
          this.loading = false
        }
      }
    },

    togglePassword() {
      this.showPassword = !this.showPassword
    }
  }
}
</script>
<style scoped>
.fill-height {
  min-height: 50vh;
}

.signup-card {
  max-width: 480px;
  width: 100%;
}

.signup-header {
  color: white;
  border-radius: 12px 12px 0 0 !important;
}

.signup-btn {
  background: #689f38 !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 48px !important;
  border-radius: 8px !important;
}

.v-text-field {
  margin-bottom: 8px;
}

.v-text-field .v-field {
  border-radius: 8px;
}

.v-checkbox {
  align-items: flex-start;
}

.v-checkbox .v-selection-control__wrapper {
  margin-top: 2px;
}

@media (max-width: 600px) {
  .signup-card {
    margin: 16px;
  }

  .signup-header {
    padding: 24px 16px !important;
  }

  .v-card-text {
    padding: 24px 16px !important;
  }
}
</style>
